import { render, staticRenderFns } from "./PreparedReviewedBy.vue?vue&type=template&id=44b003e1"
import script from "./PreparedReviewedBy.vue?vue&type=script&lang=js"
export * from "./PreparedReviewedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports